import React from "react";
import { useSearchParams, Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import Themes from "@/components/Themes";

export default function StorefrontThemePublicPreview() {
  const [params] = useSearchParams();
  const theme = (params.get("theme") || "").toLowerCase();

  // theme parametresi yoksa direkt vitrin
  if (!theme) {
    return <Themes />;
  }

  // TODO: Buraya gerçek tema componentlerini bağlayacağız
  // if (theme === "luxury") return <LuxuryTheme />;
  // if (theme === "modern") return <ModernTheme />;

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-xl rounded-xl bg-white shadow p-6 text-center">
        <h1 className="text-2xl font-bold mb-2">{theme} teması önizleme</h1>

        <p className="text-gray-600 mb-6">
          Bu alan public preview için ayrıldı. Buraya gerçek storefront tema bileşenini bağlayacağız.
        </p>

        <div className="flex items-center justify-center gap-3">
          <Button asChild variant="outline">
            <Link to="/themes-preview">Vitrine dön</Link>
          </Button>

          <Button asChild>
            <Link to="/auth">Giriş yap ve düzenle</Link>
          </Button>
        </div>
      </div>
    </div>
  );
}